var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.314 20.9697C15.67 25.6137 8.14043 25.6137 3.49636 20.9697C-1.14771 16.3256 -1.14771 8.79607 3.49636 4.152C8.14043 -0.492073 15.67 -0.492073 20.314 4.152C24.9581 8.79607 24.9581 16.3256 20.314 20.9697Z",
    fill: "url(#paint0_radial_1632_2307)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1632_2307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3447 8.79956L12.5017 17.6195H10.8889L7.03333 8.79956H8.80991L11.7457 15.6035L14.7067 8.79956H16.3447Z",
    fill: "#978CE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3447 8.79956L12.5017 17.6195H10.8889L7.03333 8.79956H8.80991L11.7457 15.6035L14.7067 8.79956H16.3447Z",
    fill: "#F0EEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1632_2307",
    x: 7.03333,
    y: 8.79956,
    width: 9.31134,
    height: 12.8198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1632_2307"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1632_2307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.1691 3.38756) rotate(175.633) scale(42.1666 22.7934)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.285647,
    stopColor: "#6B63CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573896,
    stopColor: "#55499E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#483982"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.cd67bcbf7d3c6bbdd1b102e10a7ed660.svg";
export { ForwardRef as ReactComponent };